import React from "react";
import PropTypes from "prop-types";
import { Box, H2, Spacer } from "orcs-design-system";
import LoadingPage from "../../LoadingPage";
import PrincipleSetSelector from "./PrincipleSetSelector";

const NoPrincipleSet = ({
  mutating,
  team,
  principleSets = [],
  setPrincipleSetId,
  disabled = false,
}) => (
  <Box
    overflow="visible"
    bg="white"
    boxBorder="default"
    borderRadius="2"
    p="r"
    height="100%"
  >
    <Spacer mt="s">
      <H2 sizing="small" weight="light" mb="r">
        Principles
      </H2>
      <PrincipleSetSelector
        mutating={mutating}
        team={team}
        principleSets={principleSets}
        setPrincipleSetId={setPrincipleSetId}
        disabled={disabled}
      />
      {mutating && <LoadingPage waitingFor="selectingPrincipleSet" />}
    </Spacer>
  </Box>
);

NoPrincipleSet.propTypes = {
  team: PropTypes.object,
  mutating: PropTypes.bool,
  principleSets: PropTypes.array,
  setPrincipleSetId: PropTypes.func,
  disabled: PropTypes.bool,
};

export default NoPrincipleSet;
